module.exports = __webpack_public_path__ + "static/media/ruza_sente.b69393dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/ruza_sente.jpg
// module id = 424
// module chunks = 0